<nx-spinner size="large"></nx-spinner>
